"use strict";
/** @jsx jsx */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const spinner_1 = require("@chakra-ui/spinner");
const core_1 = require("@emotion/core");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const CircularLoader = (_a) => {
    var { width, height, speed, thickness, color } = _a, rest = __rest(_a, ["width", "height", "speed", "thickness", "color"]);
    return (core_1.jsx(spinner_1.Spinner, Object.assign({ thickness: thickness, speed: speed, emptyColor: styles_scss_1.default.lightGrey, color: color, width: width, height: height }, rest)));
};
CircularLoader.defaultProps = {
    width: '40px',
    height: '40px',
    speed: '0.65s',
    thickness: '4px',
    color: styles_scss_1.default.primary
};
exports.default = CircularLoader;
